import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import config from '../config';
import { steps } from '../helpers/const';

const cookieData = Cookies.get(config.quoteCookie);

// Check if the vehicle can be purchased through financing
const getFinancingValue = () => {
  if (window?.ecommerceData?.financial?.financial !== 'true') {
    return false;
  }
  const { vehicle, financial } = window.ecommerceData;
  if (!Number.isNaN(vehicle.price) && !Number.isNaN(financial.conditions.min_price)) {
    return vehicle.price >= financial.conditions.min_price;
  }
  return true;
};

const initialState = {
  leadId: 0,
  personalData: {
    tradeIn: window?.ecommerceData?.financial?.trade !== 'not-active',
    financing: getFinancingValue(),
    receiveOffer: false,
  },
  selectedServices: [],
  files: [],
  servicesTotal: 0,
  financialData: {},
  quote: {
    files: [],
  },
  cookie: typeof cookieData !== 'undefined' ? JSON.parse(Cookies.get(config.quoteCookie)) : {},
  quoteSteps: [
    { id: 'makemodel', isValid: false },
    { id: 'tech', isValid: false },
    { id: 'data', isValid: false },
    { id: 'resume', isValid: true },
  ],
};
/* eslint-disable no-param-reassign */
export const leadSlice = createSlice({
  name: 'lead',
  initialState,
  reducers: {
    updateLeadId: (state, action) => {
      const { payload } = action;
      state.leadId = payload;
    },
    updateLeadServices: (state, action) => {
      const { payload } = action;
      state.selectedServices = payload;
      state.servicesTotal = payload
        .map((item) => item.value).reduce((prev, curr) => prev + parseInt(curr, 10), 0);
    },
    updateFinancialData: (state, action) => {
      const { payload } = action;
      state.financialData = payload;
    },
    updatePersonalData: (state, action) => {
      const { payload } = action;
      state.personalData = { ...state.personalData, ...payload };
    },
    updateLeadFiles: (state, action) => {
      const { payload } = action;
      const { step } = payload;
      const files = step === steps.trade ? state.quote.files : state.files;
      if (payload.action === 'ADD') {
        files.push(payload.files);
      } else if (payload.action === 'REMOVE') {
        for (let i = files.length - 1; i >= 0; i -= 1) {
          if (files[i].id === payload.files.id) {
            files.splice(i, 1);
          }
        }
      }
    },
    updateQuoteData: (state, action) => {
      const { payload: newQuoteData } = action;
      state.quote = { ...state.quote, ...newQuoteData };
    },
    updateQuoteStepValidation: (state, action) => {
      // Single quote step validation update
      const { idx: stepIndex, isValid: newValidationState } = action.payload;
      state.quoteSteps[stepIndex].isValid = newValidationState;
    },
    updateQuoteStepsValidation: (state, action) => {
      // All quote steps validation update
      const { quoteSteps: currentQuoteSteps } = state;
      const { isValid: newValidationState } = action.payload;
      const updatedQuoteSteps = [];

      currentQuoteSteps.forEach((step) => {
        updatedQuoteSteps.push({
          id: step.id,
          isValid: newValidationState,
        });
      });

      state.quoteSteps = updatedQuoteSteps;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateLeadId,
  updateLeadServices,
  updateLeadFiles,
  updatePersonalData,
  updateFinancialData,
  updateQuoteData,
  updateQuoteStepValidation,
  updateQuoteStepsValidation,
} = leadSlice.actions;
export const leadState = (state) => state.lead;
export default leadSlice.reducer;
